import { render } from "./winner.vue?vue&type=template&id=5056285b"
import script from "./winner.vue?vue&type=script&lang=js"
export * from "./winner.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__